"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _nano = require("./nano");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports["default"] = (0, _nano.sheet)(_objectSpread({
  list: {
    display: 'flex',
    padding: '5px',
    margin: '5px 0',
    listStyleType: 'none'
  },
  list_wrap: {
    flexFlow: 'wrap'
  },
  list_column: {
    flexDirection: 'column'
  }
}, Array(5).fill(1).reduce(function (p, n, i) {
  return _objectSpread(_objectSpread({}, p), {}, (0, _defineProperty2["default"])({}, "list--columns_".concat(n + i), {
    '& li': {
      flexBasis: "calc(100% / ".concat(n + i, ")")
    }
  }));
}, {})));